import React from 'react';
import { Trans, useTranslation } from 'next-i18next';
import MarketingSection from 'src/components/MarketingSection';
import styles from './styles.module.scss';

const TitleSection = () => {
    const { t } = useTranslation();

    return (
        <MarketingSection containerClassName={styles.container} className={styles.inner}>
            <p className={styles.title}>{t('private_market_title_1')}</p>
            <p className={styles.description}>
                <Trans i18nKey="private_market_description_1" />
            </p>
            <p className={styles.title}>{t('private_market_title_2')}</p>
            <p className={styles.description}>
                <Trans i18nKey="private_market_description_2" />
            </p>
        </MarketingSection>
    );
};

export default TitleSection;
